import * as _4 from 'lodash4';
import { IContactChannel, IResponseData } from '../notification_settings_interfacaes';
import { PhoneNumberService } from '../services/phone_number_service';

export class ContactInformationModel {
  private storedNumber?: string;
  model: any;

  constructor(private accountModel: any, private ngPhoneNumberService: PhoneNumberService) {
    // tslint:disable-next-line:no-unused-expression
    this.model = {
      email: accountModel.email,
      phoneNumber: {
        target: undefined,
        is_verified: false
      }
    };
  }

  initialize(channelsObj: IContactChannel): void {
    let emailAddress = this.accountModel.email;
    if (_4.isEmpty(emailAddress)) {
      emailAddress = _4.result(channelsObj, 'phone.student');
    }

    if (!_4.isUndefined(channelsObj.phone)) {
      this.model.phoneNumber = channelsObj.phone;
    }
    this.model.email = emailAddress;
  }

  updateEmail(newEmail: string): string {
    return (this.model.email = this.accountModel.email = newEmail);
  }

  preparePhoneNumber(newNumber: string): string {
    this.storedNumber = this.ngPhoneNumberService.sanitizePhoneNumber(newNumber) as string;
    this.model.phoneNumber = {
      target: this.storedNumber,
      is_verified: false
    };
    return this.storedNumber;
  }

  checkResponseNumber(responseData: IResponseData): boolean {
    const responseNumber = (_4(responseData.channel).values().first() as any).target;
    return this.storedNumber === responseNumber;
  }

  hasPreparedNumber(): boolean {
    return !_4.isUndefined(this.storedNumber);
  }

  isVerifiedNumberFromServer(responseData: IResponseData) {
    const responseNumber: any = _4(responseData.channel).values().first();
    if (this.storedNumber === responseNumber.target && responseNumber.is_verified) {
      this.model.phoneNumber = responseNumber;
      this.storedNumber = undefined;
      return responseNumber;
    } else {
      return false;
    }
  }

  isStoredNumber(testNumber: string): boolean {
    return testNumber === this.storedNumber;
  }

  isVerifiedPhoneNumber(): boolean {
    return this.model.phoneNumber.is_verified;
  }

  getEmail(): string {
    return this.model.email;
  }

  updateWithAccountModelEmail(): string {
    this.model.email = this.accountModel.email;
    return this.model.email;
  }

  getPhoneNumber(): string {
    return this.model.phoneNumber.target;
  }

  getDisplayPhoneNumber(): string {
    return this.ngPhoneNumberService.getDisplayNumber(this.model.phoneNumber.target) || '';
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/models/contact_information_model.ts